// extracted by mini-css-extract-plugin
export default {"myClaimsTable":"MyClaimsTable_myClaimsTable__MamJ6","myClaimActions":"MyClaimsTable_myClaimActions__ozdq8","sortingIcon":"MyClaimsTable_sortingIcon__3hVtA"};